<div class="form-actions">
  <ng-content></ng-content>
</div>
